import { dateAdd } from "@pentacode/core";
import type { DateString } from "@pentacode/openapi";
import type { SeriesRow } from "@pentacode/ui/charts";

export function flatCostEdges(rows: readonly SeriesRow<string>[], from: DateString, to: DateString) {
    const flatEdge = (source: DateString, x: DateString) =>
        rows.filter((row) => row.x === source).map((row) => ({ ...row, x }));
    return {
        before: flatEdge(from, dateAdd(from, { days: -1 })),
        after: flatEdge(dateAdd(to, { days: -1 }), to),
    };
}
